import { LoanType } from '@apply/constants';
import { ApplicationCrumbType } from './types/ApplicationCrumbType';
import { ApplicationCrumbOption } from './types/ApplicationCrumbOption';

export const ApplicationEntrySections: ApplicationCrumbOption[] = [
    {
        id: ApplicationCrumbType.BasicInfo,
        children: 'Basic Info',
        enabled: false,
        config: [
            { loanType: LoanType.Construction, sortOrder: 1 },
            { loanType: LoanType.Rental, sortOrder: 1 },
            { loanType: LoanType.BuildRent, sortOrder: 1 },
            { loanType: LoanType.Model, sortOrder: 1 },
            { loanType: LoanType.Land, sortOrder: 1 },
            { loanType: LoanType.FixFlip, sortOrder: 1 },
            { loanType: LoanType.MasterNote, sortOrder: 1 },
            { loanType: LoanType.SubNoteConstruction, sortOrder: 1 },
            { loanType: LoanType.SubNoteFixFlip, sortOrder: 1 },
            { loanType: LoanType.Bridge, sortOrder: 1 },
        ],
    },
    {
        id: ApplicationCrumbType.Property,
        children: 'Property',
        enabled: false,
        config: [
            { loanType: LoanType.Construction, sortOrder: 2 },
            { loanType: LoanType.Rental, sortOrder: 2 },
            { loanType: LoanType.BuildRent, sortOrder: 2 },
            { loanType: LoanType.Model, sortOrder: 2 },
            { loanType: LoanType.Land, sortOrder: 2 },
            { loanType: LoanType.FixFlip, sortOrder: 2 },
            { loanType: LoanType.MasterNote, sortOrder: 2 },
            { loanType: LoanType.SubNoteConstruction, sortOrder: 2 },
            { loanType: LoanType.SubNoteFixFlip, sortOrder: 2 },
            { loanType: LoanType.Bridge, sortOrder: 2 },
        ],
    },
    {
        id: ApplicationCrumbType.Budget,
        children: 'Budget',
        enabled: false,
        config: [
            { loanType: LoanType.Construction, sortOrder: 3 },
            { loanType: LoanType.BuildRent, sortOrder: 3 },
            { loanType: LoanType.Model, sortOrder: 3 },
            { loanType: LoanType.Land, sortOrder: 3 },
            { loanType: LoanType.FixFlip, sortOrder: 3 },
            { loanType: LoanType.SubNoteConstruction, sortOrder: 3 },
            { loanType: LoanType.SubNoteFixFlip, sortOrder: 3 },
        ],
    },
    {
        id: ApplicationCrumbType.Specs,
        children: 'Specs',
        enabled: false,
        config: [
            { loanType: LoanType.Construction, sortOrder: 4 },
            { loanType: LoanType.BuildRent, sortOrder: 4 },
            { loanType: LoanType.Model, sortOrder: 4 },
            { loanType: LoanType.FixFlip, sortOrder: 4 },
            { loanType: LoanType.SubNoteConstruction, sortOrder: 4 },
            { loanType: LoanType.SubNoteFixFlip, sortOrder: 4 },
        ],
    },
    {
        id: ApplicationCrumbType.Review,
        children: 'Review',
        enabled: false,
        config: [
            { loanType: LoanType.Construction, sortOrder: 5 },
            { loanType: LoanType.Rental, sortOrder: 3 },
            { loanType: LoanType.BuildRent, sortOrder: 5 },
            { loanType: LoanType.Model, sortOrder: 5 },
            { loanType: LoanType.Land, sortOrder: 4 },
            { loanType: LoanType.FixFlip, sortOrder: 5 },
            { loanType: LoanType.MasterNote, sortOrder: 3 },
            { loanType: LoanType.SubNoteConstruction, sortOrder: 5 },
            { loanType: LoanType.SubNoteFixFlip, sortOrder: 5 },
            { loanType: LoanType.Bridge, sortOrder: 3 },
        ],
    },
];

export function getApplicationCrumbsForLoanType(
    loanType: LoanType | undefined
): Array<ApplicationCrumbOption & { number: number }> {
    const filtered = ApplicationEntrySections.filter((crumb) => crumb.config.some((c) => c.loanType === loanType)).sort(
        (a, b) => {
            const aOrder = a.config.find((c) => c.loanType === loanType)!.sortOrder;
            const bOrder = b.config.find((c) => c.loanType === loanType)!.sortOrder;
            return aOrder - bOrder;
        }
    );

    return filtered.map((crumb, index) => ({
        ...crumb,
        number: index + 1,
    }));
}
